import React from 'react';
import { Mic, MicOff } from 'lucide-react';
import { Box, useTheme } from '@mui/material';

const SummaryRecordingIcon = ({recording = false, disabled = false}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: 60,
        height: 60,
        borderRadius: '50%',
        bgcolor: recording ? theme.palette.secondary.main : disabled ? 'rgba(0,0,0, 0.04)' : '#D8D8D8',
        boxShadow: recording
          ? `0px 2px 2px 0px rgba(0, 0, 0, 0.20) inset, 0px 0px 4px ${theme.palette.secondary.main}`
          : '0px 2px 2px 0px rgba(0, 0, 0, 0.20) inset, 0px 0px 4px rgb(195, 195, 195)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: 46,
          height: 46,
          borderRadius: '50%',
          bgcolor: 'white',
          boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.25)',
          overflow: 'hidden', // Ensures inner element is clipped to circle
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            background: 'linear-gradient(0deg, #E4E4E4, #ffffff)',
            WebkitMask:
              'radial-gradient(circle, transparent calc(54px), black calc(4px))',
            pointerEvents: 'none',
            transform: 'translateZ(0)',
          }}
        />
        {recording ? (
          <Mic
            size='32px'
            style={{
              strokeWidth: 1.4,
              color: recording ? 'inherit' : '#A1A1AA',
            }}
          />
        ) : (
          <MicOff
            size='32px'
            style={{
              strokeWidth: 1.4,
              color: recording ? 'inherit' : disabled ? '#EDEDED' : '#A1A1AA',
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default SummaryRecordingIcon;
